"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalCache = getLocalCache;
exports.getSessionCache = getSessionCache;
exports.StorageCache = exports.DEFAULT_CACHE_TTL = void 0;

var _storage = require("./storage");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/


// If a user does not open any discovery based solution in 28 days, cache will be removed.
var DEFAULT_CACHE_TTL = 4 * 7 * 86400; // 4 weeks (seconds).

exports.DEFAULT_CACHE_TTL = DEFAULT_CACHE_TTL;

var StorageCache =
/** @class */
function () {
  function StorageCache(storageInstance, storageKey, cacheExpiry) {
    if (cacheExpiry === void 0) {
      cacheExpiry = DEFAULT_CACHE_TTL;
    }

    this.storageKey = storageKey;
    this.storage = storageInstance;
    this.cacheExpiry = cacheExpiry;
  }
  /**
   * Reads the entire cache from storage.
   * @returns {{[key: string]: T}} Cache content
   * @private
   */


  StorageCache.prototype.read = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.storage.get(this.storageKey)];

          case 1:
            return [2
            /*return*/
            , _a.sent() || {}];
        }
      });
    });
  };
  /**
   * Writes the entire cache to storage, removing expired items along the way.
   * @param {[key: string]: T} cache - Cache content
   * @private
   */


  StorageCache.prototype.write = function (cache) {
    return __awaiter(this, void 0, Promise, function () {
      var now, key;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            now = Date.now(); // Remove any expired entries

            for (key in cache) {
              if (cache[key].expires < now) {
                delete cache[key];
              }
            }

            return [4
            /*yield*/
            , this.storage.set(this.storageKey, cache, this.cacheExpiry * 1000)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Returns a cached entry if exists and valid.
   * @param {string} key - Entry key
   *
   * @returns {CacheEntry} Cached entry
   */


  StorageCache.prototype.get = function (key) {
    return __awaiter(this, void 0, Promise, function () {
      var cache, entry;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.read()];

          case 1:
            cache = _a.sent();
            entry = cache[key];

            if (entry && entry.expires > Date.now()) {
              return [2
              /*return*/
              , entry];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Stores an entry in the cache.
   * @param {string} key - Entry key
   * @param {CacheEntry} entry to be cached.
   */


  StorageCache.prototype.set = function (key, entry) {
    return __awaiter(this, void 0, Promise, function () {
      var cache;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.read()];

          case 1:
            cache = _a.sent();
            cache[key] = entry;
            return [4
            /*yield*/
            , this.write(cache)];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Removes an entry from the cache if exists.
   * @param {string} key - Entry key
   */


  StorageCache.prototype.remove = function (key) {
    return __awaiter(this, void 0, Promise, function () {
      var cache;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.read()];

          case 1:
            cache = _a.sent();
            if (!cache[key]) return [3
            /*break*/
            , 3];
            delete cache[key];
            return [4
            /*yield*/
            , this.write(cache)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return StorageCache;
}();

exports.StorageCache = StorageCache;

function getLocalCache(storageKey, cacheExpiry) {
  return new StorageCache(_storage.storage.local, storageKey, cacheExpiry);
}

function getSessionCache(storageKey, cacheExpiry) {
  return new StorageCache(_storage.storage.session, storageKey, cacheExpiry);
}